import { useState, useEffect } from 'react';

import { callerIdService } from '../../../../../../services';

type UseCallerIdResult = {
  callerId: string | null;
  lineName: string | null;
  isLoading: boolean;
  error: string | null;
};

export const useCallerId = (customerPhone?: string): UseCallerIdResult => {
  const [callerId, setCallerId] = useState<string | null>(null);
  const [lineName, setLineName] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!customerPhone) {
      setCallerId(null);
      setLineName(null);
      setError(null);
      setIsLoading(false);
      return;
    }

    let cancelled = false;

    const fetchCallerId = async() => {
      setIsLoading(true);
      setError(null);

      try {
        const result = await callerIdService.getCallerId(customerPhone);
        if (cancelled) return;

        setCallerId(result.callerId ?? null);
        setLineName(result.lineName ?? null);
        if (!result.callerId) {
          setError('Caller ID not found');
        }
      } catch {
        if (cancelled) return;
        setCallerId(null);
        setLineName(null);
        setError('Failed to load caller ID');
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    fetchCallerId();

    return () => {
      cancelled = true;
    };
  }, [customerPhone]);

  return { callerId, lineName, isLoading, error };
};
